export default {"src":"/_next/static/media/mail_24.95ad92a1.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};